import { NavButton } from '@/components/nav-button';
import { NUCLEUS_VAULTS } from '@/constants/nucleus-vaults';
import { AppRoute, plumeMainnetId } from '@/constants/shared';
import { useNucleusVaults } from '@/hooks/useNucleusVaults';
import { NucleusClient } from '@/network/clients/nucleus';
import { Box, HStack } from '@chakra-ui/react';
import { useAppKitAccount } from '@reown/appkit/react';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { StrategyCard, StrategyCardSkeleton } from './StrategyCard';

// const INPUT_TOKEN_SYMBOLS = ['WPLUME', 'pUSD', 'USDC.e', 'nALPHA', 'nBASIS'];

const client = new NucleusClient();

export const AllStrategies = () => {
  const [selectedSymbol] = useState<string | undefined>();
  // const onSelectSymbol = (symbol: string) => {
  //   if (symbol === selectedSymbol) setSelectedSymbol(undefined);
  //   else setSelectedSymbol(symbol);
  // };
  const { address } = useAppKitAccount();
  const { data: currentPortfolioData, isLoading: isLoadingCurrentPortfolioData } = useQuery({
    queryKey: ['currentPortfolio', address],
    queryFn: () => {
      if (!address) return undefined;
      return client.get('protocol/current_portfolio', { userAddress: address });
    },
    enabled: Boolean(address),
  });

  const { nucleusVaults, isPendingVaults } = useNucleusVaults();
  return (
    <Box w="full">
      {/* <Text fontWeight="500" fontSize="md" color="fg.muted" mb={4}>
        Input Assets
      </Text> */}
      <HStack
        mb={[4, 4, 4, 8]}
        flexWrap={['wrap', 'wrap', 'wrap', 'nowrap']}
        gap={2}
        overflow={['visible', 'visible', 'visible', 'auto']}
      >
        {/* {INPUT_TOKEN_SYMBOLS.map((symbol) => (
          <RoundedButton
            key={symbol}
            h={9}
            bgColor={symbol === selectedSymbol ? 'fg' : 'bg'}
            color={symbol === selectedSymbol ? 'bg' : 'fg'}
            variant="outline"
            onClick={() => onSelectSymbol(symbol)}
          >
            <Image src={getIconPathFromTokenSymbol(symbol)} boxSize={5} />
            {symbol}
          </RoundedButton>
        ))} */}
        <NavButton direction="fwd" href={AppRoute.Bridge} bgColor="bg" _hover={{ bgColor: 'bg.subtle' }}>
          Bridge to Plume
        </NavButton>
      </HStack>
      {isPendingVaults && NUCLEUS_VAULTS.map((_, idx) => <StrategyCardSkeleton key={idx} />)}
      {(nucleusVaults ?? [])
        .filter((vault) =>
          Object.values(vault.deposit.sourceChains[plumeMainnetId].depositTokens).find(({ symbol }) =>
            selectedSymbol ? selectedSymbol.toLowerCase() === symbol.toLowerCase() : true,
          ),
        )
        .map(({ vaultMetadata }) => {
          const { quantity = 0, total_value_in_usd = 0 } =
            currentPortfolioData?.vaults?.[vaultMetadata.vaultAddress] ?? {};
          return (
            <StrategyCard
              key={vaultMetadata.vaultKey}
              yourDeposits={quantity}
              yourDepositsUSD={total_value_in_usd}
              vaultMetadata={vaultMetadata}
              loading={isLoadingCurrentPortfolioData}
            />
          );
        })}
    </Box>
  );
};
